import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { TrailerTailTypeForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditTrailerTailType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const trailerTailType = useSelector((state) => state.trailerTailType);
  const [wheel, setWheel] = React.useState(trailerTailType?.wheel);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: trailerTailType.name,
      description: trailerTailType.description,
      type_code: trailerTailType.type_code,
      wheel: trailerTailType.wheel,
    },
  });

  useEffect(() => {
    dispatch(actions.trailerTailTypeGet(id));
    return () => {};
  }, []);
  useEffect(() => {
    setWheel(trailerTailType?.wheel);
    return () => {};
  }, [trailerTailType]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      const dataSubmit = {
        ...data,
        wheel,
      };

      await dispatch(actions.trailerTailTypePut(id, dataSubmit));
      await dispatch(actions.trailerTailTypeGet(id));
      alert('สำเร็จ');
    } catch (error) {
      console.log(error);
    }
  };

  if (trailerTailType.isLoading || trailerTailType.rows) {
    return <Loading />;
  }
  if (!trailerTailType.isLoading && trailerTailType.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <TrailerTailTypeForm
                errors={errors}
                trailerTailType={trailerTailType}
                control={control}
                Controller={Controller}
                wheel={wheel}
                setWheel={setWheel}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
EditTrailerTailType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditTrailerTailType.defaultProps = {
  title: '',
  subtitle: '',
};
